export function toRMBYuan(fen, hasUnit) {
  if (typeof fen !== 'number') return fen
  const unit = hasUnit ? '￥' : '';
  if (fen) {
    const price = ((fen / 100) + '').indexOf('.') > -1 ? (fen / 100).toFixed(2) : (fen / 100)
    return unit + Number(price);
  } else {
    return unit + '0';
  }
}

export function elemStatus (status) {
  if (!status) {
    return ''
  } else if (status === 'PAID') {
    return '付款订单'
  } else if (status === 'FINISH') {
    return '结算订单'
  }
}

export function meituanStatus (status) {
  if (!status) {
    return ''
  } else if (status === 'UNCONFIRME') {
    return '付款订单'
  } else if (status === 'FINISH') {
    return '结算订单'
  }
}


export default {
  toRMBYuan,
  elemStatus,
  meituanStatus,
}
